var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaffeeColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.62C6.09 5.62 5.75 5.28 5.75 4.87V3.11999C5.75 2.71 6.09 2.37 6.5 2.37C6.91 2.37 7.25 2.71 7.25 3.11999V4.87C7.25 5.29 6.91 5.62 6.5 5.62Z",
    fill: "url(#paint0_linear_847_25403)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.62C10.09 5.62 9.75 5.28 9.75 4.87V3.11999C9.75 2.71 10.09 2.37 10.5 2.37C10.91 2.37 11.25 2.71 11.25 3.11999V4.87C11.25 5.29 10.91 5.62 10.5 5.62Z",
    fill: "url(#paint1_linear_847_25403)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.62C14.09 5.62 13.75 5.28 13.75 4.87V3.11999C13.75 2.71 14.09 2.37 14.5 2.37C14.91 2.37 15.25 2.71 15.25 3.11999V4.87C15.25 5.29 14.91 5.62 14.5 5.62Z",
    fill: "url(#paint2_linear_847_25403)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 13.75C22.75 11.13 20.72 9.01001 18.16 8.79001C17.42 7.58001 16.1 6.76001 14.58 6.76001H7.21C4.89 6.76001 3 8.65001 3 10.97V11.5H18.79V10.97C18.79 10.78 18.76 10.59 18.73 10.41C20.18 10.84 21.25 12.16 21.25 13.75C21.25 15.32 20.21 16.63 18.79 17.07V12.5H3V18.29C3 20.61 4.89 22.5 7.21 22.5H14.58C16.78 22.5 18.57 20.8 18.75 18.64C21.03 18.18 22.75 16.16 22.75 13.75Z",
    fill: "url(#paint3_linear_847_25403)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_847_25403",
    x1: 6.5,
    y1: 2.37,
    x2: 6.5,
    y2: 5.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_847_25403",
    x1: 10.5,
    y1: 2.37,
    x2: 10.5,
    y2: 5.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_847_25403",
    x1: 14.5,
    y1: 2.37,
    x2: 14.5,
    y2: 5.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_847_25403",
    x1: 12.875,
    y1: 6.76001,
    x2: 12.875,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaffeeColorIcon);
export default __webpack_public_path__ + "static/media/caffee-color-icon.e86f5fe794a8d9ae8a0c1e946b68783f.svg";
export { ForwardRef as ReactComponent };